import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { ImageEditor } from '../';

import { FlagContext } from '../../../flags/Flags';

import './ImagePanel.scss';

class ImagePanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNewSelectableRow: this.props.showNewSelectableRow || false
    };
  }

  addSelectable = () => {
    this.setState({
      showNewSelectableRow: true
    });
  };

  newSelectableAllowed(flags) {
    return !(flags && flags.isReadonly) && !this.state.showNewSelectableRow;
  }

  render() {
    return (
      <FlagContext.Consumer>
        {flags => (
          <div className="slds-grid slds-wrap">
            <div className="slds-col image-panel">
              <ImageEditor
                actions={this.props.actions}
                selectables={this.props.assets}
                onSelectableChange={this.props.onSelectableChange.bind(this)}
                onAddSelectable={this.addSelectable}
                onDeleteSelectable={this.props.onDeleteSelectable}
                onDisableSelectable={this.props.onDisableSelectable}
                showNewSelectableRow={this.state.showNewSelectableRow}
                canAddSelectable={this.newSelectableAllowed(flags)}
                status={this.props.status}
              />
            </div>
          </div>
        )}
      </FlagContext.Consumer>
    );
  }
}

ImagePanel.propTypes = {
  actions: PropTypes.object,
  assets: PropTypes.array,
  onSelectableChange: PropTypes.func.isRequired,
  onDeleteSelectable: PropTypes.func.isRequired,
  onDisableSelectable: PropTypes.func.isRequired,
  status: PropTypes.string,
  history: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(ImagePanel);
